export enum JourneyRouteName {
	APPLY_UPDATE = 'apply-update',
	APPLY_VIEW = 'apply-view',
	APPLY_OVERVIEW = 'apply-overview',

	EVALUATE_OVERVIEW = 'evaluate-overview',
	EVALUATE_DETAILS = 'evaluate-details',
}
